// Shared constants for consistent sizing across Swimlane and Gantt views
export const SWIMLANE_MIN_HEIGHT = 97.06; // Minimum height for all sections

// Gantt-specific constants for precise positioning
export const GANTT_BAR_HEIGHT = 16;
export const GANTT_PADDING_ABOVE = 6;
export const GANTT_PADDING_BELOW = 6;
export const GANTT_ITEM_HEIGHT = GANTT_BAR_HEIGHT + GANTT_PADDING_ABOVE + GANTT_PADDING_BELOW; // 28px
export const GANTT_SECTION_PADDING = GANTT_PADDING_ABOVE;
